import { styled } from '@mui/material';

export const NotAccessPermissionContainer = styled('div')({
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
});
